import { DatumOffer } from "kreate-common/modules/business-types";
import { CLIENT_ENV } from "kreate-env/client";

// coupled with packages/kreate-protocol/offchain/tx/acceptOffer.ts
const MIN_ROYALTY = 1_000_000;

type LovelaceAmount = number;

type Ratio = number;

type ProfitBreakdown = {
  artworkPrice: LovelaceAmount;
  artistReceives: LovelaceAmount;
  royaltyRate: Ratio;
  protocolReceives: LovelaceAmount;
  transactionFeeEstimated: LovelaceAmount;
  sellerReceivesEstimated: LovelaceAmount;
};

type Params = {
  datumOffer: DatumOffer | null | undefined;
  numEditions: number | null | undefined;
};

export function getProfitBreakdown({
  datumOffer,
  numEditions,
}: Params): ProfitBreakdown | undefined {
  if (datumOffer == null || numEditions == null) return undefined;
  const artworkPrice = datumOffer.editionPrice * numEditions;
  const artistReceives = Math.max(
    datumOffer.editionRoyalty * numEditions,
    MIN_ROYALTY
  );
  const royaltyRate = datumOffer.editionRoyalty / datumOffer.editionPrice;
  const protocolReceives = Math.max(
    Math.floor((artworkPrice * CLIENT_ENV.KOLLECTOR_MINT_FEE_PERCENTAGE) / 100),
    CLIENT_ENV.MIN_PROTOCOL_FEE
  );
  const transactionFeeEstimated = 1_600_000;
  const sellerReceivesEstimated =
    artworkPrice - artistReceives - protocolReceives - transactionFeeEstimated;
  return {
    artworkPrice,
    artistReceives,
    royaltyRate,
    protocolReceives,
    transactionFeeEstimated,
    sellerReceivesEstimated,
  };
}
